<template>
  <rect x="3" y="14" width="11" height="1" transform="rotate(-90 3 14)" fill="#A6A6A6" />
  <rect x="5" y="9" width="1" height="2" transform="rotate(-90 5 9)" fill="#A6A6A6" />
  <rect x="8" y="9" width="1" height="2" transform="rotate(-90 8 9)" fill="#A6A6A6" />
  <rect x="11" y="9" width="1" height="2" transform="rotate(-90 11 9)" fill="#A6A6A6" />
</template>
